module.exports = __webpack_public_path__ + "static/media/LI8.98fbe696.jpg";